import { useDispatch, useSelector } from 'react-redux';

import { getPullRequestViewSyncStrategies } from 'src/redux/pull-request/selectors';
import { prCommitActions } from 'src/redux/repo-commits/actions';
import { getRepoCommitsState } from 'src/redux/repo-commits/selectors';
import { RepositoryCommitListProps } from 'src/sections/repository/components/commit-list';

export const usePullRequestCommitListDetails =
  (): RepositoryCommitListProps => {
    const { commits, hasError, isLoading, nextUrl } =
      useSelector(getRepoCommitsState);
    const syncStrategies = useSelector(getPullRequestViewSyncStrategies);
    const dispatch = useDispatch();

    return {
      commits: commits || [],
      hasError,
      isLoading,
      hasMore: !!nextUrl,
      syncStrategies,
      retryAction: () => dispatch({ type: prCommitActions.RETRY_COMMITS }),
      fetchMoreAction: () =>
        dispatch({ type: prCommitActions.FETCH_MORE_COMMITS }),
    };
  };

export const usePrCommitCount = (): string => {
  const { commits, hasMore } = usePullRequestCommitListDetails();
  return `${commits.length}${hasMore ? '+' : ''}`;
};
